import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';

const CategoryCard = ({ category }) => {
  const [hovered, setHovered] = useState(false);

  const styles = {
    link: {
      textDecoration: 'none',
      display: 'block',
    },
    card: {
      background: 'white',
      border: `1px solid ${hovered ? '#3182ce' : '#f3f4f6'}`,
      borderRadius: '12px',
      padding: '1.5rem',
      boxShadow: hovered
        ? '0 8px 24px rgba(49, 130, 206, 0.12)'
        : '0 1px 3px rgba(0,0,0,0.05)',
      transition: 'all 0.3s ease',
      transform: hovered ? 'translateY(-2px)' : 'translateY(0)',
      cursor: 'pointer',
    },
    inner: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '1rem',
    },
    content: {
      flex: 1,
      minWidth: 0,
    },
    name: {
      fontSize: '1.15rem',
      fontWeight: 600,
      color: hovered ? '#3182ce' : '#1f2937',
      marginBottom: '0.4rem',
      transition: 'color 0.2s',
    },
    description: {
      fontSize: '0.875rem',
      color: '#6b7280',
      lineHeight: 1.6,
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      margin: 0,
    },
    viewRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.4rem',
      marginTop: '0.85rem',
      fontSize: '0.875rem',
      fontWeight: 500,
      color: '#3182ce',
    },
    arrow: {
      transition: 'transform 0.2s ease',
      transform: hovered ? 'translateX(4px)' : 'translateX(0)',
    },
    iconCircle: {
      width: '3.5rem',
      height: '3.5rem',
      borderRadius: '50%',
      background: hovered ? '#3182ce' : '#ebf8ff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      transition: 'background 0.3s ease',
    },
    iconLetter: {
      fontSize: '1.3rem',
      fontWeight: 700,
      color: hovered ? 'white' : '#3182ce',
      transition: 'color 0.3s ease',
      lineHeight: 1,
    },
  };

  return (
    <Link
      to={`/products?category=${category.id}`}
      style={styles.link}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={styles.card}>
        <div style={styles.inner}>
          {/* Text content */}
          <div style={styles.content}>
            <h3 style={styles.name}>{category.name}</h3>

            {category.description && (
              <p style={styles.description}>{category.description}</p>
            )}

            <div style={styles.viewRow}>
              <span>មើលទំនិញ</span>
              <FiArrowRight style={styles.arrow} />
            </div>
          </div>

          {/* Icon circle */}
          <div style={styles.iconCircle}>
            <span style={styles.iconLetter}>
              {category.name.charAt(0).toUpperCase()}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default CategoryCard;